import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const kingsMoorMetadata = {
  id: 'kings-moor',
  name: "King's Moor",
  description:
    'An ancient, austere championship crossing windswept high moor, heather, stone walls and deep irregular hazards.',
  environmentPreset: 'kings-moor',
  metadata: {
    location: 'Northmarch Moor',
    regionType: 'heathland/moorland',
    difficulty: 92,
    typicalWind: [9, 21] as const,
    greenSpeed: [11, 12] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Creative ground routes through wind, slopes, heather and deep sand',
    signatureHoles: [2, 8, 13, 18],
    tournamentEventId: 'event-19',
    previewTheme: 'kings-moor',
    environmentPalette: {
      fairway: '#66704b',
      rough: '#655b3f',
      bunker: '#b59b69',
      water: '#475b60',
      haze: '#8b8980',
      sky: '#777d80',
      rock: '#6d695e',
    },
    vegetationStyle: 'treeless heather and coarse moor grass',
    terrainStyle: terrainPreset('kings-moor', 27, 95, 1.4).id,
    sunlightDirection: 'low muted northern light',
    distantScenery: 'stone walls across empty high ground',
    waterStyle: 'dark peat burns',
    eventPresentation: {
      accentColor: '#a78b51',
      mark: 'WORLD HERITAGE',
      subtitle: 'Old ground. Endless wind.',
      loadingCopy: 'Read the ancient slopes',
      identityLine: 'Historic high moorland championship golf',
      tierLabel: 'MAJOR CHAMPIONSHIP',
    },
  },
};
const pars = [4, 4, 3, 4, 4, 3, 4, 3, 5, 5, 4, 3, 5, 4, 4, 3, 4, 4],
  yards = [
    430, 455, 185, 420, 470, 175, 440, 145, 565, 455, 425, 205, 555, 465, 435, 190, 450, 485,
  ];
const names = [
  'Moor Gate',
  'Blind King',
  'Heather Pot',
  'Old Road',
  'High March',
  'Gray Sky',
  'Peat Ridge',
  'Nine Pits',
  'Running Stag',
  'Cross Wall',
  'Austere',
  'Burn',
  'Ground Game',
  'Gold Heather',
  'Long Hollow',
  'Wind Bell',
  'Last Ridge',
  'Stone Home',
];
const o: Partial<HolePlan>[] = [];
o[1] = { elevation: { tee: 0, landing: 18, green: 5 }, bunkerCount: 5 };
o[7] = { bunkerCount: 8, greenRadius: 14 };
o[12] = { splitFairway: true, bunkerCount: 4 };
o[17] = {
  rocks: 10,
  bunkerCount: 6,
  landingZones: [{ distance: 275, width: 31, preferredSide: 'right' }],
};
export const createKingsMoorDocument = () =>
  authorCourse({
    ...kingsMoorMetadata,
    plans: plans(names, pars, yards, o).map((p) => ({
      ...p,
      trees: p.trees ?? 0,
      rocks: p.rocks ?? 2,
    })),
  });
